// The public site's origin for this admin build, derived from REACT_APP_API
// (api.<domain> -> <domain>, dev-api.<domain> -> dev.<domain>,
// staging-api.<domain> -> staging.<domain>). REACT_APP_PORTAL_URL overrides it.
// Returns null when it cannot be derived, so callers hide "View on site".
export function portalOrigin(apiUrl = process.env.REACT_APP_API, override = process.env.REACT_APP_PORTAL_URL) {
  if (override) return String(override).replace(/\/+$/, "");
  let url;
  try {
    url = new URL(apiUrl);
  } catch (_) {
    return null;
  }
  const host = url.hostname;
  const map = [
    ["dev-api.", "dev."],
    ["staging-api.", "staging."],
    ["api.", ""],
  ];
  for (const [prefix, replacement] of map) {
    if (host.startsWith(prefix)) return `${url.protocol}//${replacement}${host.slice(prefix.length)}`;
  }
  return null;
}

/** Public page of a News/Events post, or null. Detail pages live at /news-details/:slug. */
export function newsPostUrl(slug, apiUrl, override) {
  const origin = portalOrigin(apiUrl, override);
  if (!origin || !slug) return null;
  return `${origin}/news-details/${encodeURIComponent(slug)}`;
}
